import React from "react";
import { Box } from "@mui/material";
import Autocomplete, {
  AutocompleteChangeReason,
} from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { GenresArray, MoodsArray } from "../constants";
import { autoCompleteStlye, useStyles } from "../../pages/MyTracks/styles";
import { BatchTrackModalDetailsProps } from "./types";
import { batchTrackDetailsStyles } from "./styles";
import { FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const BatchTrackModalDetails: React.FC<BatchTrackModalDetailsProps> = ({
  values,
  handleChange,
  handleBlur,
  isSubmitting,
  genres,
  setGenres,
  moods,
  setMoods,
  setFieldValue,
}) => {
  const classes = useStyles();

  return (
    <>
      <Box className="input">
        <p className="optional-input" style={{ marginTop: 25 }}>
          The following fields will be applied from ID3 metadata tags on your
          music files. You can also provide a default below that will be applied
          if the metadata is missing.
        </p>
        <label style={{ color: TEXT_COLOR }} htmlFor="artist">
          Artist <span className="optional-input">(optional)</span>
        </label>
        <input
          style={batchTrackDetailsStyles.artistInput}
          type="text"
          name="artist"
          id="artist"
          placeholder="Artist"
          value={values.artist}
          onChange={handleChange}
          onFocus={(e) => {
            e.target.style.boxShadow =
              "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)";
            e.target.style.border = "1px solid gray";
          }}
          onBlur={(e) => {
            e.target.style.boxShadow = "none";
            e.target.style.border = `1px solid gray`;
            handleBlur(e);
          }}
          disabled={isSubmitting}
        />
      </Box>
      <Box className="input">
        <label style={{ color: TEXT_COLOR }} htmlFor="album">
          Album <span className="optional-input">(optional)</span>
        </label>
        <input
          style={batchTrackDetailsStyles.albumInput}
          type="text"
          name="album"
          id="album"
          placeholder="Album"
          value={values.album}
          onChange={handleChange}
          onFocus={(e) => {
            e.target.style.boxShadow =
              "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)";
            e.target.style.border = "1px solid gray";
          }}
          onBlur={(e) => {
            e.target.style.boxShadow = "none";
            e.target.style.border = `1px solid gray`;
            handleBlur(e);
          }}
          disabled={isSubmitting}
        />
      </Box>
      <Box>
        <Box style={{ marginBottom: 20 }}>
          <label htmlFor="genres" style={batchTrackDetailsStyles.genreLabel}>
            {" "}
            Genre <span className="optional-input">(optional)</span>
          </label>
          <Stack spacing={3}>
            <Autocomplete
              disabled={isSubmitting}
              autoComplete
              value={genres || []}
              sx={autoCompleteStlye}
              options={GenresArray}
              multiple={true}
              onChange={(
                event: React.SyntheticEvent<Element, Event>,
                value: string[] | null,
                _reason: AutocompleteChangeReason
              ) => {
                if (value != null) {
                  setGenres(value);
                  setFieldValue("genres", value);
                } else {
                  setGenres([]);
                  setFieldValue("genres", "");
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=" "
                  InputLabelProps={{
                    shrink: false,
                  }}
                  classes={{ root: classes.customTextField }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} style={{ fontFamily: FONT_FAMILY }}>
                  {option}
                </li>
              )}
            />
          </Stack>
        </Box>
        <Box style={{ marginBottom: 20 }}>
          <label htmlFor="moods" style={batchTrackDetailsStyles.genreLabel}>
            {" "}
            Mood <span className="optional-input">(optional)</span>
          </label>
          <Stack spacing={3}>
            <Autocomplete
              disabled={isSubmitting}
              autoComplete
              multiple
              value={moods || []}
              sx={autoCompleteStlye}
              options={MoodsArray}
              onChange={(
                event: React.SyntheticEvent<Element, Event>,
                value: string[] | null,
                _reason: AutocompleteChangeReason
              ) => {
                if (value != null) {
                  setMoods(value);
                  setFieldValue("moods", value);
                } else {
                  setMoods([]);
                  setFieldValue("moods", "");
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label=" "
                  InputLabelProps={{
                    shrink: false,
                  }}
                  classes={{ root: classes.customTextField }}
                />
              )}
              renderOption={(props, option) => (
                <li {...props} style={{ fontFamily: FONT_FAMILY }}>
                  {option}
                </li>
              )}
            />
          </Stack>
        </Box>
      </Box>
    </>
  );
};
